import { useDispatch } from 'react-redux';
import { setSnakbar } from 'actions/app_action';

interface ShowRequestSnackbarProps {
  successCondition: boolean;
  successCallback?: () => void;
  successMessage?: string;
  errorMessage?: string;
  errorCallback?: () => void;
  duration?: number;
  warningCondition?: boolean;
  warningMessage?: string;
  warningCallback?: () => void;
}

const useRequestSnackbar = () => {
  const dispatch = useDispatch();

  const showRequestSnackbar = ({
    successCondition,
    successCallback,
    successMessage = defaultSuccessMessage,
    errorMessage = defaultErrorMessage,
    errorCallback,
    duration = 3000,
    warningCondition = false,
    warningMessage = defaultErrorMessage,
    warningCallback
  }: ShowRequestSnackbarProps) => {
    let snackbarData = {
      type: 'success',
      message: successMessage
    };
    if (successCondition) {
      successCallback && successCallback();
    } else if (warningCondition) {
      warningCallback && warningCallback();
      snackbarData = {
        type: 'warning',
        message: warningMessage
      };
    } else {
      errorCallback && errorCallback();
      snackbarData = {
        type: 'error',
        message: errorMessage
      };
    }
    dispatch(
      setSnakbar({
        isOpen: true,
        time: duration,
        ...snackbarData
      })
    );
  };

  return { showRequestSnackbar };
};

const defaultSuccessMessage = 'Änderungen wurden übernommen.';
const defaultErrorMessage = 'Ein Fehler ist aufgetreten.';

export default useRequestSnackbar;
